import { motion } from "framer-motion";
import { AnimatedSection, AnimatedGroup, AnimatedItem, useCounter } from "./AnimatedSection";
const SocialProof = () => {
  const stat1 = useCounter(48, 1.5);
  const stat2 = useCounter(40, 1.5);
  const stat3 = useCounter(98, 1.5);
  return <section className="pt-16 md:pt-20 pb-8 md:pb-10 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-muted/30 via-muted/50 to-muted/30 py-[123px]" />

      <div className="container mx-auto px-6 relative">
        {/* Stats Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 max-w-4xl mx-auto mb-20">
          <AnimatedSection delay={0}>
            <div className="text-center" ref={stat1.ref}>
              <p className="text-5xl md:text-6xl font-bold text-primary mb-2">
                {stat1.count}h
              </p>
              <p className="text-sm text-muted-foreground font-medium">Délai de livraison</p>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.1}>
            <div className="text-center" ref={stat2.ref}>
              <p className="text-5xl md:text-6xl font-bold text-primary mb-2">
                -{stat2.count}%
              </p>
              <p className="text-sm text-muted-foreground font-medium">Rendez-vous manqués</p>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.2}>
            <div className="text-center" ref={stat3.ref}>
              <p className="text-5xl md:text-6xl font-bold text-primary mb-2">
                {stat3.count}%
              </p>
              <p className="text-sm text-muted-foreground font-medium">Satisfaction client</p>
            </div>
          </AnimatedSection>
        </div>

        {/* Logos */}
        <AnimatedSection>
          <div className="text-center mb-8">
            <p className="text-sm text-muted-foreground uppercase tracking-wider font-medium">
              Ils nous font confiance
            </p>
          </div>
        </AnimatedSection>

        <div className="relative">
          {/* Fade edges */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />

          <AnimatedGroup className="flex items-center justify-center gap-8 md:gap-16 flex-wrap">
            {["Martin & Associés", "Dupont Avocats", "Leblanc Legal", "Moreau & Partners", "Bernard Law"].map((name, index) => <AnimatedItem key={index}>
                <div className="px-6 py-3 text-lg font-semibold text-muted-foreground/40 hover:text-muted-foreground/60 transition-colors cursor-default">
                  {name}
                </div>
              </AnimatedItem>)}
          </AnimatedGroup>
        </div>
      </div>
    </section>;
};
export default SocialProof;